import styled from "styled-components";

export const SAddProjectModalSectionItemCheckmarkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--active-icon-01);
`;
